<template>
  <div>
    <!-- 搜索筛选 -->
    <div class="query-select">
      <el-form :inline="true" :model="queryForm">
        <el-form-item label="标题">
          <el-input
            style="width: 360px;"
            v-model.trim="queryForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="addForms"
          >新增</el-button
        >
      </div>
    </div>
    <!--列表-->
    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="title"
          label="标题"
          width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="recipientType"
          label="接收对象"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ recipientTypeLabel(scope.row.recipientType) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="sendTime"
          label="发送时间	"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="sendStatus"
          label="状态	"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.sendStatus == 0 ? "未发送" : "已发送" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openDetail(scope.row.messageCenterId)"
              >详情</el-button
            >
            <el-button
              plain
              round
              size="small"
              v-if="scope.row.sendStatus != 0"
              type="primary"
              @click="repeatMessage(scope.row.messageCenterId)"
              >重新发送</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="deleteInfo(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>
    <MessageForm ref="messageFormRef" @success="search" />
    <MessageDetail ref="messageDetailRef" />
  </div>
</template>

<script>
import { getMessageList, deleteMessage, repeatMessage } from "@/api/message";
import MessageForm from "./MessageForm.vue";
import MessageDetail from "./MessageDetail.vue";
export default {
  components: {
    MessageForm,
    MessageDetail
  },
  data() {
    return {
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        content: null
      },
      listData: [],
      totals: 0,
      loading: false
    };
  },

  /**
   * 创建完毕
   */
  created() {
    this.loading = true;
    this.search();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    recipientTypeLabel(type) {
      const map = {
        1: "全部学员",
        2: "指定学员"
      };
      return map[type] || "-";
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.search();
    },
    // 关联随堂测验

    resetSelect() {
      this.queryForm = {
        pageNum: 1,
        pageSize: 10,
        content: ""
      };
      this.search();
    },
    // 搜索事件
    async search() {
      try {
        this.loading = true;
        const result = await getMessageList(this.queryForm);
        this.listData = result.data.rows;
        this.totals = result.data.total;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },
    async repeatMessage(id) {
      try {
        await repeatMessage(id);
        this.$message.success("重新发送成功");
        this.search();
      } catch (e) {}
    },
    addForms() {
      this.$refs.messageFormRef.open();
    },
    openDetail(id) {
      this.$refs.messageDetailRef.open(id);
    },
    // 删除
    deleteInfo(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row);
          deleteMessage(row.messageCenterId);
          this.$message.success("删除成功");
          this.search();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/Message/index.vue